import { createSlice } from "@reduxjs/toolkit";
import {
  addStore,
  addStoreByShopifyApp,
  getAllRecordsByUser,
  getAllStores,
  getAllUsers,
  getAnnouncement,
  getCurrentStore,
  getStoresByUser,
  getTotals,
  getTotalsOfCustomerData,
  getUserActiveStores,
} from "../../api/store";

const initialState = {
  isAdded: false,
  isLoading: false,
  addedStore: null,
  addSucceed: false,
  storeInfo: null,
  storeDetails: [],
  activeUserStores: [],
  allStores: [],
  storesByUser: [],
  orderTabIndex: null,
  allUsers: [],
  userRecords: [],
  shopifyAppStore: null,
  shopifyAppUserDetails: null,
  totalsOfAdmin: null,
  announcement: null,
  totalsOfCustomerData: null,
  revenueDetails: null,
  cogsRevenueBalance: null,
  ordersStatistics: null,
  topSellingProducts: null,
  disputeReturnedOrdersData: null,
};

export const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    getStoreName: (state, action) => {
      state.addedStore = action.payload;
    },
    getOrderTabIndex: (state, action) => {
      state.orderTabIndex = action.payload;
    },
    getShopifyAppUserDetails: (state, action) => {
      state.shopifyAppUserDetails = action.payload;
    },
    resetShopifyAppStoreData: (state, action) => {
      state.shopifyAppStore = action.payload;
    },
  },
  extraReducers: {
    [addStore.pending]: (state) => {
      state.isLoading = true;
    },
    [addStore.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.addedStore = payload;
    },
    [addStore.rejected]: (state) => {
      state.isLoading = false;
    },
    [addStoreByShopifyApp.pending]: (state) => {
      state.isLoading = true;
    },
    [addStoreByShopifyApp.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.shopifyAppStore = payload;
    },
    [addStoreByShopifyApp.rejected]: (state) => {
      state.isLoading = false;
    },
    [getAllStores.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllStores.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.allStores = payload;
    },
    [getAllStores.rejected]: (state) => {
      state.isLoading = false;
    },
    [getStoresByUser.pending]: (state) => {
      state.isLoading = true;
    },
    [getStoresByUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.storesByUser = payload;
    },
    [getStoresByUser.rejected]: (state) => {
      state.isLoading = false;
    },
    [getTotals.pending]: (state) => {
      state.isLoading = true;
    },
    [getTotals.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.totalsOfAdmin = payload;
    },
    [getTotals.rejected]: (state) => {
      state.isLoading = false;
    },
    [getAllUsers.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllUsers.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.allUsers = payload;
    },
    [getAllUsers.rejected]: (state) => {
      state.isLoading = false;
    },
    [getAllRecordsByUser.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllRecordsByUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.userRecords = payload;
    },
    [getAllRecordsByUser.rejected]: (state) => {
      state.isLoading = false;
    },
    [getUserActiveStores.pending]: (state) => {
      state.isLoading = true;
    },
    [getUserActiveStores.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.activeUserStores = payload;
    },
    [getUserActiveStores.rejected]: (state) => {
      state.isLoading = false;
    },
    [getCurrentStore.pending]: (state) => {
      state.isLoading = true;
      state.isError = null;
    },
    [getCurrentStore.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.storeInfo = payload;
    },
    [getCurrentStore.rejected]: (state) => {
      state.isLoading = false;
    },
    [getAnnouncement.pending]: (state) => {
      state.isLoading = true;
      state.isError = null;
    },
    [getAnnouncement.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.announcement = payload;
    },
    [getAnnouncement.rejected]: (state) => {
      state.isLoading = false;
    },
    [getTotalsOfCustomerData.pending]: (state) => {
      state.isLoading = true;
      state.isError = null;
    },
    [getTotalsOfCustomerData.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.totalsOfCustomerData = payload;
    },
    [getTotalsOfCustomerData.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const {
  getStoreName,
  getOrderTabIndex,
  getShopifyAppUserDetails,
  resetShopifyAppStoreData,
} = storeSlice.actions;
export const storeSelector = (state) => state.store;
export default storeSlice.reducer;
